import {Link, Typography} from '@mui/material';
import React from 'react';
import {Link as RouterLink} from 'react-router';
import {getRentalAgreementURL} from "../../../util/BookingUtil";
import {styled} from "@mui/material/styles";

const LocationProfileBeforeList = styled('ul')(() => ({
  listStyleType: 'disc',
  listStylePosition: 'outside',
  marginTop: '1rem',
  paddingLeft: '1.35rem',
}));

const LocationProfileBeforeRouterLink = styled(RouterLink)(({theme}) => ({
  color: theme.palette.secondary.main,
}));

const LocationProfileBeforeLink = styled(Link)(({theme}) => ({
  color: theme.palette.secondary.main,
}));

interface LocationProfileBeforeYouBookProps {
  rentalAgreementFileName?: string;
}

const LocationProfileBeforeYouBook = (props: LocationProfileBeforeYouBookProps) => {
  const {rentalAgreementFileName} = props;

  const rentalAgreementURL = getRentalAgreementURL(rentalAgreementFileName);

  return (
    <section>
      <Typography variant='h6' color='textPrimary'>Before You Book</Typography>
      <LocationProfileBeforeList>
        <li>
          <LocationProfileBeforeRouterLink to="/terms-of-use" target="_blank">Terms of Use
            Policy</LocationProfileBeforeRouterLink>
        </li>
        <li>
          <LocationProfileBeforeLink href={rentalAgreementURL} target="_blank">Rental Agreement
            Policy</LocationProfileBeforeLink>
        </li>
      </LocationProfileBeforeList>
    </section>
  );
};

export default LocationProfileBeforeYouBook;
